import OpeningHoursEditor from '../../OpeningHoursEditor';

const HoursTab = (props) => <OpeningHoursEditor {...props} />;

export default HoursTab;
